// File Name: pages/match-pages/matchConfig.js
//
// The handful of values that will change once the app ships. One place on
// purpose — these are the only edits needed when the Play listing goes live.

/**
 * The Play Store listing.
 *
 * ⚠️ PLACEHOLDER. The id is settled (`org.nellab.yno`, decided 2026-08-20) but
 * the listing does not exist yet, so this URL currently 404s on Play. Swap it
 * for the real link the moment the app is approved.
 *
 * Set this to `null` instead if you would rather the pages say honestly that the
 * app is not on any store yet — GetAppCard handles both.
 */
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=org.nellab.yno';

/** The app's Android package name. Needed by the Phase 2 deep-link work. */
export const ANDROID_PACKAGE = 'org.nellab.yno';

/** Where the marketing site lives, for the footer link. */
export const SITE_URL = 'https://nellab.org';

/** The app's only email contact route. */
export const SUPPORT_EMAIL = 'ibralisyed@gmail.com';

/**
 * The YNO OTP/join Worker. Its /guest-join endpoint performs the join.
 *
 * The join runs server-side rather than writing to Firestore from here: the
 * host's "new player joined" notification lives under
 * `users/{adminUid}/notifications`, which security rules gate on being signed
 * in, and a web guest never is. A browser-side join would put the player in
 * the lobby and tell nobody.
 */
export const JOIN_SERVICE_URL = 'https://yno-otp.yno-otp-server.workers.dev';
